
import Vue from 'vue';
import {mapActions, mapGetters, mapMutations} from 'vuex';
import ILocation from '../interfaces/ilocation';

declare const Alkami: any;

export default Vue.extend({
  name: 'location-details',
  data() {
    return {
      Alkami,
      isVisible: false,
      selectedLocation: {} as ILocation
    };
  },
  computed: {
      ...mapGetters(['getSelectedLocation'])
  },
  watch: {
      getSelectedLocation(value: ILocation) {
      this.isVisible = !!value;
      this.selectedLocation = value;
    }
  },
    methods: {
        ...mapActions(
            [
                'deselectLocation'
            ]
        ),
        ...mapMutations(
            [
                'setSelectedLocation'
            ]
        ),
        clearSelectedLocation() {
            this.isVisible = false;
            this.setSelectedLocation(null);
            this.deselectLocation();
        }
    }
});
